export default function ICheckedBlack({
  width = 24,
  height = 24,
  color = '#3B9B60',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.5 11.25C19.5 6.69365 15.8063 3 11.25 3C6.69365 3 3 6.69365 3 11.25C3 15.8063 6.69365 19.5 11.25 19.5C15.8063 19.5 19.5 15.8063 19.5 11.25ZM21 11.25C21 16.6348 16.6348 21 11.25 21C5.86522 21 1.5 16.6348 1.5 11.25C1.5 5.86522 5.86522 1.5 11.25 1.5C16.6348 1.5 21 5.86522 21 11.25Z"
        fill={color}
      />
      <path
        d="M11.25 2.25C16.2206 2.25 20.25 6.27944 20.25 11.25C20.25 16.2206 16.2206 20.25 11.25 20.25C6.27944 20.25 2.25 16.2206 2.25 11.25C2.25 6.27944 6.27944 2.25 11.25 2.25ZM16.457 7.84277C16.0665 7.45237 15.4335 7.45237 15.043 7.84277L9.25 13.6357L6.95703 11.3428C6.56653 10.9524 5.93347 10.9524 5.54297 11.3428C5.15248 11.7333 5.15254 12.3663 5.54297 12.7568L8.54297 15.7568C8.93349 16.1474 9.56651 16.1474 9.95703 15.7568L16.457 9.25684C16.8475 8.8663 16.8475 8.23327 16.457 7.84277Z"
        fill={color}
      />
    </svg>
  );
}
